'use client';

import { useTheme } from '@/components/ThemeComponents/ThemeProvider';
import React from 'react';

export function ThemedBackground({ children }: { children: React.ReactNode }) {
  const themeData = useTheme();
  const backgroundColor1 = themeData?.theme?.calVariable?.backgroundColor1;
  const backgroundColor2 = themeData?.theme?.calVariable?.backgroundColor2;
  const lightenHexColor = (hex: string, amount: number): string => {
    const num = parseInt(hex.replace('#', ''), 16);
    const r = Math.min(255, (num >> 16) + amount);
    const g = Math.min(255, ((num >> 8) & 0x00ff) + amount);
    const b = Math.min(255, (num & 0x0000ff) + amount);

    return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
  };

  if (themeData?.application?.backgroundImageKey) {
    return (
      <div
        style={{
          backgroundImage: `url(${themeData.application.backgroundImageKey})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '100vh',
        }}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      style={{
        // background: themeData?.theme?.variable?.primaryColor, // fallback color
        backgroundColor: themeData?.theme?.calVariable?.primaryColor
          ? lightenHexColor(themeData.theme.calVariable.primaryColor, 200)
          : '#ffffff',
        minHeight: '100vh',
      }}
    >
      {children}
    </div>
    // <div
    //   style={{
    //     // background: themeData?.theme?.variable?.primaryColor, // fallback color
    //     background: `linear-gradient(180deg,${backgroundColor1} 0%, ${backgroundColor2} 100%)`,
    //     minHeight: '100vh',
    //   }}
    // >
    //   {children}
    // </div>
  );
}
